var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns is-centered is-mobile"},[_c('div',{staticClass:"column is-two-thirds-tablet is-four-fifths-mobile mt-6"},[_c('vue-simple-markdown',{attrs:{"source":_vm.src}}),_c('center',[_c('a',{attrs:{"href":"mailto:website@labstreaminglayer.org"}},[_vm._v("website@labstreaminglayer.org")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }